export enum LabelImageType {
    Seljan = 'Seljan',
    Kolorcans = 'Kolorcans',
    Suncast = 'Suncast',
    FHNoble = 'F.H. Noble',
}